import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CaisServiceService } from '../../cais-service.service';
import { CaisExceptionServiceService } from '../../exceptions/cais-exception-service.service';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { RecordDetailsComponent } from '../record-details/record-details.component';
import { ErrorCodeDetailsComponent } from '../error-code-details/error-code-details.component';
import { FdidRecordDetailsComponent } from '../fdid-record-details/fdid-record-details.component';
import { LtidDetailsComponent } from '../ltid-details/ltid-details.component';
import { AddressDetailsComponent } from '../address-details/address-details.component';
import { CustomerlistDetailsComponent } from '../customerlist-details/customerlist-details.component';
import { ButtonModule } from 'primeng/button';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-edit',
    imports: [ToastModule, DialogModule, MatProgressSpinner, CommonModule, RecordDetailsComponent, ErrorCodeDetailsComponent,
        FdidRecordDetailsComponent, LtidDetailsComponent, AddressDetailsComponent, CustomerlistDetailsComponent, ButtonModule, MatListModule],
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit {

  @Input('finraExceptionRow') finraExceptionRow: any;
  @Input('screenType') screenType: any;

  isEditLoadingResults = false;
  isClickedOnce: boolean = false;
  countryList: any = [];
  countryRegionList: any = [];

  addScreenNegotiatedFields: Array<string>;
  editScreenNegotiatedFields: Array<string>;
  viewScreenNegotiatedFields: Array<string>;
  CommonNegotiatedFields: Array<string>;
  DisabledFields: Array<string>;
  editDisabledFields: Array<string>;
  ExceptionalFDIDScreenFields: Array<string>;
  CountryFields: Array<string>;

  addressColumns: any = [];
  addressColumnJson: any = [];
  NaturalPersoncols: any = [];
  LegalEntitycols: any = [];
  TIDcols: any = [];
  LTIDGridColumns: any = [];
  ExceptionCodeDetailsCols: any = [];

  fdidScreenDataDetails: any = [];
  NaturalPersonScreenDataDetails: any = [];
  LegalEntityScreenDataDetails: any = [];
  LTIDScreenDataDetails: any = [];
  TIDScreenDataDetails: any = [];

  ExceptionCodesDetails!: any[];
  ExceptionInCustomerIDList!: any[];
  NaturalPersons: any = [{
    id: 0,
    name: "Add Natural Person",
    inCustomerRecordID:''
  }];
  LegalEntities: any = [{
    id: 0,
    name: "Add Legal Entity",
    inCustomerRecordID:''
  }];


  tbldatamsg!: string;



  constructor(public caisExceptionServiceService: CaisExceptionServiceService,
    public caisServiceService: CaisServiceService,
    private messageService: MessageService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlService: UrlsService,
    private userService: UserService,
  ) {
    this.addScreenNegotiatedFields = this.caisServiceService.addScreenNegotiatedFields;
    this.editScreenNegotiatedFields = this.caisServiceService.editScreenNegotiatedFields;
    this.viewScreenNegotiatedFields = this.caisServiceService.viewScreenNegotiatedFields;
    this.CommonNegotiatedFields = this.caisServiceService.CommonNegotiatedFields;
    this.DisabledFields = this.caisServiceService.DisabledFields;
    this.editDisabledFields = this.caisServiceService.editDisabledFields;
    this.ExceptionalFDIDScreenFields = this.caisServiceService.ExceptionalFDIDScreenFields;
    this.CountryFields = this.caisServiceService.CountryFields;
    this.finraExceptionRow = this.caisExceptionServiceService.rowDataforDialog;
  }

  getColumns() {
    this.caisServiceService.getColumns();
    this.addressColumnJson = this.caisServiceService.addressColumnJson;
    this.addressColumns = this.caisServiceService.addressColumns;
    this.NaturalPersoncols = this.caisServiceService.NaturalPersoncols;
    this.LegalEntitycols = this.caisServiceService.LegalEntitycols;
    this.LTIDGridColumns = this.caisServiceService.LTIDGridColumns;
    this.TIDcols = this.caisServiceService.TIDcols;
    this.ExceptionCodeDetailsCols = this.caisExceptionServiceService.exceptionDetailsColumns;
  }

  ngOnInit() {
    this.getColumns();
    this.caisServiceService.getScreenData(this.finraExceptionRow);
    this.updateFileds();
    this.getExceptionView();
  }

  getExceptionView() {
    this.caisServiceService.FDIDScreenDataDetails = [];
    this.caisServiceService.FDIDAddressDetails = [];
    this.caisServiceService.NaturalPersonDataDetails = [];
    this.caisServiceService.NaturalPersonAddressDetails = [];
    this.caisServiceService.LegalEntityDataDetails = [];
    this.caisServiceService.LegalEntityAddressDetails = [];
    this.caisServiceService.removedCustomers = [];
    this.ExceptionCodesDetails = [];
    this.isEditLoadingResults = true;
    let firmDesignatedID = this.finraExceptionRow["firmDesignatedID"];
    let accountNumber = this.finraExceptionRow["accountNumber"];
    let receivedFDID = this.finraExceptionRow["receivedFDID"];
    if(firmDesignatedID && (!receivedFDID || receivedFDID.length == 0)){
      receivedFDID = firmDesignatedID;
    }
    /* FDID View Detail */
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.CAIS_Exception_View
      ), {
      type: "MASTER",
      source: this.finraExceptionRow["source"],
      CATReporterIMID: this.userService.getActiveMPID(),
      firmDesignatedID: firmDesignatedID,
      accountNumber: accountNumber,
      receivedFDID: ((!receivedFDID || receivedFDID.length == 0) ? receivedFDID : firmDesignatedID),
      reportDate: this.finraExceptionRow["reportDate"],
      customerRecordID: this.finraExceptionRow["customerRecordID"],
      inCustomerRecordID: this.finraExceptionRow["inCustomerRecordID"],
      user: this.userService.getUserName(),
      userName: this.userService.getUserFirstName()
    }
    ).subscribe({
      next: (element:any) => {
      let dataset: any = element;
      this.tbldatamsg = "No data found";
      let exceptionList: any;
      this.isEditLoadingResults = false;
      if (dataset) {
        let tabIndex = 0;
        if (dataset.fdidDetails && dataset.fdidDetails !== null) {
          this.caisServiceService.loadFDIDDetails(dataset.fdidDetails, this.finraExceptionRow);
          this.caisServiceService.loadFDIDAddress(dataset.fdidAddrDetails);
          this.caisServiceService.loadLTIDDetails(dataset.ltidDetails)
          this.NaturalPersons = this.caisServiceService.loadTabNameArray(dataset.naturalPersonDetails, "Add Natural Person",tabIndex);
          this.caisServiceService.loadNaturalPersonDetails(dataset.naturalPersonDetails);
          this.caisServiceService.NaturalPersonAddressDetails = this.caisServiceService.prepareAddress(dataset.naturalPersonDetails);
          this.LegalEntities = this.caisServiceService.loadTabNameArray(dataset.legalEntityDetails, "Add Legal Entity",this.NaturalPersons.length);
          this.caisServiceService.loadLegalEntityDetails(dataset.legalEntityDetails);
          this.caisServiceService.LegalEntityAddressDetails = this.caisServiceService.prepareAddress(dataset.legalEntityDetails);
        } else {
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SEVERITY_ERROR, detail: "Something went wrong. Record Details Not Found" });
        }
        this.ExceptionCodesDetails = dataset.exceptionList;
        this.ExceptionInCustomerIDList = dataset.exceptionInCustomerIDList;
      }
    }, error: (err: HttpErrorResponse) => {
      this.isEditLoadingResults = false;
    }});
  }


  updateFileds() {
    this.fdidScreenDataDetails = this.caisServiceService.fdidScreenDataDetails;
    this.addressColumns = this.caisServiceService.addressColumns;
    this.NaturalPersonScreenDataDetails = this.caisServiceService.NaturalPersonScreenDataDetails;
    this.LegalEntityScreenDataDetails = this.caisServiceService.LegalEntityScreenDataDetails;
    this.LTIDScreenDataDetails = this.caisServiceService.LTIDScreenDataDetails;
    this.addressColumnJson = this.caisServiceService.addressColumnJson;
  }

  saveFDIDRecord() {
    let APIParams: any = this.caisServiceService.buildFDIDRecordPayloadToSave();
    if (!APIParams) {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SEVERITY_ERROR, detail: 'Please update the required fields' });
    } else {
      this.isClickedOnce = true;
      this.isEditLoadingResults = true;
      let url = APIURL.CAIS_FINRA_Edit;
      if (this.userService.caisExceptionType == "CLIENT") {
        url = APIURL.CAIS_CLIENT_Edit
      }
      this.sharedHttpClientService.post(
        this.urlService.setAPIURl(
          url
        ), APIParams)
        .subscribe({
          next: (res:any) => {
          this.isClickedOnce = false;
          this.isEditLoadingResults = false;

          let dataset: any = res;
          if (dataset.status === true) {
            this.caisExceptionServiceService.isCaisEdit = false;
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }, error: (err: HttpErrorResponse) => {
          this.isClickedOnce = false;
          this.isEditLoadingResults = false;
        }});
    }
  }
}
